import TinyStore from 'lib/tinyStore';

type DataUpdatedFlagModal = {
    patientFeedbackListUpdated?: undefined | {};
    patientListUpdated?: undefined | {};
    surveyDataUpdated?: undefined | {};
    billingDataUpdated?: undefined | {};
};

const Store = TinyStore.createStore<DataUpdatedFlagModal>({
    nameSpace: 'klarity',
    key: 'dataUpdatedFlag',
    crossBundle: false,
    runTime: true,
    initValue: {
        patientFeedbackListUpdated: undefined,
        patientListUpdated: undefined,
        surveyDataUpdated: undefined,
        billingDataUpdated: undefined,
    },
});
export default Store;
